import { render, staticRenderFns } from "./ShopifyProductForm.vue?vue&type=template&id=2b51aa54&"
import script from "./ShopifyProductForm.vue?vue&type=script&lang=js&"
export * from "./ShopifyProductForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports